export default __webpack_public_path__ + "static/media/Vector.6f924faa.svg";